/**
 * Template Registry
 * Dynamically imports all HTML templates from the templates folder
 * Allows flexible template loading without hardcoding imports
 */

// Use Vite's glob import to load all HTML files as raw strings
const templateModules = import.meta.glob<string>(
  './*.html',
  { as: 'raw', eager: true }
);

// Build a registry of templates keyed by their path
export const templateRegistry: Record<string, string> = {};

Object.entries(templateModules).forEach(([filePath, content]) => {
  // Extract filename from path (e.g., "./landingpage1.html" -> "landingpage1.html")
  const filename = filePath.replace('./', '');
  // Store with "templates/" prefix to match .env format
  const key = `templates/${filename}`;
  templateRegistry[key] = content;
  console.log('Registered template:', key);
});

console.log('Available templates:', Object.keys(templateRegistry));

/**
 * Get a template by its name
 * @param templatePath - Path like "templates/landingpage1.html"
 * @returns The HTML content or null if not found
 */
export const getTemplate = (templatePath: string): string | null => {
  console.log('Getting template:', templatePath);
  console.log('Available keys:', Object.keys(templateRegistry));
  return templateRegistry[templatePath] || null;
};

/**
 * Get list of available templates
 */
export const getAvailableTemplates = (): string[] => {
  return Object.keys(templateRegistry);
};
